module.exports = __webpack_public_path__ + "img/theme-three.0d489edf.png";